import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { SeFeTranslationsLoader } from 'se-fe-translations'

import {
  OpenRegistrationFilterOption,
  OpenRegistrationFilters,
} from '../open-registration-filter/open-registration-filter.component'

@Component({
  selector: 'se-po-open-registration-search',
  templateUrl: './open-registration-search.component.html',
  styleUrls: ['./open-registration-search.component.scss'],
  standalone: false,
})
export class OpenRegistrationSearchComponent implements OnInit {
  public readonly translationKey =
    'SE_PO_SE_REGISTRATION_UI_FEATURE_OPEN_REGISTRATION_LIST.'
  private readonly translationsPath =
    'se-registration-ui/feature-open-registration-list/assets/translations'

  @Input() public sports: OpenRegistrationFilterOption[] = []
  @Input() public signupTypeList: OpenRegistrationFilterOption[] = []
  @Input() public organizations: OpenRegistrationFilterOption[] = []

  @Output() public searchTermChange = new EventEmitter<string>()
  @Output() public filtersChange = new EventEmitter<OpenRegistrationFilters>()

  public searchTerm = ''

  constructor(private translationsLoader: SeFeTranslationsLoader) {}

  public ngOnInit(): void {
    void this.translationsLoader.load(this.translationsPath)
  }

  public handleSearchQueryChange(searchTerm: string): void {
    this.searchTerm = searchTerm
    this.searchTermChange.emit(searchTerm)
  }

  public handleFiltersChange(filters: OpenRegistrationFilters): void {
    this.filtersChange.emit(filters)
  }
}
